export function coerceTimestamp(value) {
  if (value === null || value === undefined) {
    return null;
  }
  if (value instanceof Date) {
    const ms = value.getTime();
    return Number.isFinite(ms) ? ms : null;
  }
  if (typeof value === "number") {
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) {
      return null;
    }
    return numeric > 1e12 ? numeric : Math.trunc(numeric * 1000);
  }
  if (typeof value === "string") {
    const text = value.trim();
    if (!text) {
      return null;
    }
    const parsed = Date.parse(text);
    return Number.isFinite(parsed) ? parsed : null;
  }
  if (typeof value === "object") {
    if (value.epoch !== undefined) {
      return coerceTimestamp(value.epoch);
    }
    if (value.actual !== undefined) {
      return coerceTimestamp(value.actual);
    }
    if (value.estimated !== undefined) {
      return coerceTimestamp(value.estimated);
    }
    if (value.scheduled !== undefined) {
      return coerceTimestamp(value.scheduled);
    }
    if (value.time !== undefined) {
      return coerceTimestamp(value.time);
    }
    if (value.timestamp !== undefined) {
      return coerceTimestamp(value.timestamp);
    }
    if (value.dateTime !== undefined) {
      return coerceTimestamp(value.dateTime);
    }
  }
  return null;
}

export function toTimestamp(value) {
  const ms = coerceTimestamp(value);
  return Number.isFinite(ms) ? ms : null;
}

export function normaliseLocalDateTimeInput(value) {
  if (value === undefined || value === null) {
    return null;
  }
  if (value instanceof Date) {
    const ms = value.getTime();
    return Number.isFinite(ms) ? new Date(ms).toISOString() : null;
  }
  if (typeof value === "number") {
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) {
      return null;
    }
    const millis = numeric > 1e12 ? numeric : Math.trunc(numeric * 1000);
    return new Date(millis).toISOString();
  }
  if (typeof value !== "string") {
    return null;
  }
  const text = value.trim();
  if (!text) {
    return null;
  }
  const dateWithTrailingTMatch = text.match(/^(\d{4})-(\d{2})-(\d{2})T$/);
  if (dateWithTrailingTMatch) {
    const [_, year, month, day] = dateWithTrailingTMatch;
    const composed = `${year}-${month}-${day}T00:00:00`;
    const parsed = new Date(composed);
    return Number.isNaN(parsed.getTime()) ? null : parsed.toISOString();
  }
  const dateOnlyMatch = text.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (dateOnlyMatch) {
    const [_, year, month, day] = dateOnlyMatch;
    const composed = `${year}-${month}-${day}T00:00:00`;
    const parsed = new Date(composed);
    return Number.isNaN(parsed.getTime()) ? null : parsed.toISOString();
  }
  const parsed = new Date(text);
  return Number.isNaN(parsed.getTime()) ? null : parsed.toISOString();
}
